<template>
  <v-container class="py-0">
    <v-card flat v-if="employer!==null && employer!==undefined">
      <v-card-title class="py-1" style="background-color:rgba(0,0,0,.12);"
        ><v-icon class="pr-2"> mdi-account-circle </v-icon>
        {{ $t("filebrowser.filedetails.owner") }}</v-card-title
      >
      <v-card-text>
        <v-row>
          <v-col class="py-0">
            {{ owner }}
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-title class="py-1" style="background-color:rgba(0,0,0,.12);"
        ><v-icon class="pr-2"> mdi-file-eye-outline </v-icon>
        {{ $t("filebrowser.filedetails.file_details") }}
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col align-self="center" class="py-0">{{ file.FileName }}</v-col>
          <v-col align-self="center" class="py-0">
            {{
              $t("filebrowser.filedetails.size_{0}", [
                formatBytes(file.FileSize),
              ])
            }}
          </v-col>
          <v-col align-self="center" class="py-0">
            {{ $t("filebrowser.filedetails.type_{0}", [file.FileType]) }}
          </v-col>
        </v-row>
        <v-row>
          <v-col align-self="center">
            {{
              file.Timestamp
                ? $t("filebrowser.filedetails.created_{0}", [formatDate(file.Timestamp)])
                : $t("filebrowser.filedetails.created_na")
            }}
          </v-col>
          <v-col align-self="center">
            {{
              createdBy
                ? $t("filebrowser.filedetails.created_by_{0}", [createdBy])
                : $t("filebrowser.filedetails.created_by_na")
            }}
          </v-col>
          <v-col align-self="center">
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- <v-card flat class="pl-12 py-3">
      <v-btn @click="putFile()">{{
        $t("filebrowser.filedetails.update_file")
      }}</v-btn>
    </v-card> -->
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { formatBytes } from "@/utils/file.js";
import { translate2 } from "@/trans2";

export default {
  name:"member-file-details",
  components: {},
  model: {},
  props: {
    employer: Object,
    file: Object,
    createdBy: String
  },
  data() {
    return {
      item: [],
      dialog: false,
      rules: [(v) => !!v || "This field is required"],
      loading: false,
    };
  },
  computed: {
      owner() {
        if (this.employer === null || this.employer === undefined) {
          return "";
        }
        return translate2(
          this.employer.Current,
          "Name"
        );
      }
  },
  methods: {
    ...mapActions("documentsService", ["updateFile"]),
    formatBytes,
    getDate(date) {
      return date.substring(0, date.lastIndexOf("T"));
    },
    async putFile() {
      const item = { Id: this.file.PhysicalFileId, Name: this.fileName };
      try {
        const res = (await this.updateFile({
          item: item
        })).data;
        this.file.FileName = res.Name;
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(dateString) {
      if (dateString === undefined || dateString === null) {
        return "";
      }
      const [date, time] = dateString.split("T");
      const [year, month, day] = date.split("-");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>
